import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useWindowSize } from "go-core/components/useWindowSize";
import { PurchaseContext } from "../../../../../pages/Preview";

const PurchaseCorrectionFormItemsTableHeader = () => {
	const isMobile = useWindowSize().isMobile;
	const { t } = useTranslation();
	const { purchase } = useContext(PurchaseContext);

	return (
		<thead>
			<tr>
				<th className="w-30" style={{ minWidth: isMobile ? "300px" : "unset" }}>
					{t("common.word.product")}
				</th>
				<th className="w-10" style={{ minWidth: isMobile ? "150px" : "unset" }}>
					{t("common.word.volume")}
				</th>
				<th style={{ minWidth: isMobile ? "100px" : "unset", width: isMobile ? "unset" : "7%" }}>
					{t("modules.purchase.field.was.title")}
					<br />
					{`(${t("common.word.quantity")})`}
				</th>
				<th style={{ minWidth: isMobile ? "100px" : "unset", width: isMobile ? "unset" : "7%" }}>
					{t("modules.purchase.field.should_be.title")}
					<br />
					{`(${t("common.word.quantity")})`}
				</th>
				<th className="w-10" style={{ minWidth: isMobile ? "100px" : "unset" }}>
					{t("common.word.tax")}
				</th>
				<th className="w-10" style={{ minWidth: isMobile ? "100px" : "unset" }}>
					{purchase.tax_gross
						? t("modules.purchase.field.correction_unit_price_gross.title")
						: t("modules.purchase.field.correction_unit_price_net.title")}
				</th>
				<th className="w-10" style={{ minWidth: isMobile ? "100px" : "unset" }}>
					{purchase.tax_gross
						? t("modules.purchase.field.correction_new_unit_price_gross.title")
						: t("modules.purchase.field.correction_new_unit_price_net.title")}
				</th>
				<th style={{ minWidth: isMobile ? "100px" : "unset", width: isMobile ? "unset" : "16%" }}>
					{t("common.word.value")}
				</th>
				<th className="action" />
			</tr>
		</thead>
	);
};

export default PurchaseCorrectionFormItemsTableHeader;
